import { RetryLink } from "@apollo/client/link/retry"

export default function getRetryLink() {

  return new RetryLink({
    delay: {
      initial: 1000,
      max: 3000,
      jitter: true,
    },
    attempts: {
      max: 10,
      retryIf: (error, _operation) => {
        return !!error
      },
    },
  })
}
